import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "wo-skills-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1"
  }
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "30rem"
  }
};
const _hoisted_4 = {
  style: {
    "padding": "0 64px"
  }
};
import SkillsTree from '@/components/Skills/SkillsTree.vue';
import { request } from '@/manager/net_manager';
import { onMounted, ref, computed, provide } from 'vue';
import { convertTreeData, isAdminType, sortedSkillData } from '@/tools/utils';
import { ElIcon, ElOption, ElRow, ElSelect } from 'element-plus';
import store from '@/store';
import RoleFinder from '@/components/Role/RoleFinder.vue';
import { Plus } from '@element-plus/icons-vue';
import MaskerLayer from '@/components/Basic/MaskerLayer.vue';
import SectsSkillEditCard from '@/components/Skills/SectsSkillEditCard.vue'; // constants

export default {
  __name: 'WOSkills',

  setup(__props) {
    const modeArray = [{
      label: '全览',
      value: -1
    }, {
      label: '公开',
      value: 0
    }, {
      label: '秘传',
      value: 1
    }]; // refs

    const dataArray = ref([]);
    const treeRef = ref(null);
    const treeData = ref({});
    const organization = ref(null);
    const mode = ref(-1);
    const selectedRole = ref(null);
    const skill = ref(null); // computed

    const worldOutlook = computed(() => store.state.world_outlook);
    const organizations = computed(() => {
      if (!worldOutlook.value) return [];
      return store.state.world_outlook_info[worldOutlook.value.id]?.organizations ?? [];
    });
    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4); // functions

    const getData = () => {
      if (organization.value) {
        request('skills/list/', {
          'organization_id': organization.value,
          'visibility': mode.value
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            treeData.value = {};
            dataArray.value = response.data;

            if (dataArray.value.length > 0) {
              treeData.value = convertTreeData(dataArray.value);
              treeData.value = sortedSkillData(structuredClone(treeData.value));
            }
          }
        });
      }
    };

    const updateSelectedRole = (role, isSelected = false) => {
      // console.log('castChanged', role.nickname, isSelected)
      if (isSelected) {
        selectedRole.value = role;
      } else {
        selectedRole.value = null;
      }
    };

    const createSkill = () => {
      skill.value = {};
    };

    const selectedSkill = item => {
      skill.value = item;
    };

    const closeSkill = () => {
      skill.value = null;
    }; // post-declaration


    provide('selectedSkill', selectedSkill); // lifecycle

    onMounted(() => {
      if (organizations.value.length === 0) {
        store.dispatch('get_wo_organizations');
      } else if (!organization.value) {
        organization.value = organizations.value[0].id;
        getData();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(ElRow), {
        class: "wo-skill-header"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElRow), {
          style: {
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElSelect), {
            modelValue: organization.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => organization.value = $event),
            placeholder: "选择流派",
            class: _normalizeClass(organization.value ? 'selected-selector' : ''),
            "popper-class": "roleSkillsPopper",
            onChange: getData
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (item, index) => {
              return _openBlock(), _createBlock(_unref(ElOption), {
                key: index,
                label: item['name'],
                value: item['id']
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "class"]), _createVNode(_unref(ElSelect), {
            modelValue: mode.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => mode.value = $event),
            placeholder: "一览方案",
            class: _normalizeClass(["mode-selector", mode.value >= 0 ? 'selected-selector' : '']),
            "popper-class": "roleSkillsPopper",
            onChange: getData
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(modeArray, (item, index) => {
              return _createVNode(_unref(ElOption), {
                key: index,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue", "class"]), _unref(isAdminType)(userType.value) ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "create-skill-card",
            onClick: createSkill
          }, [_createVNode(_unref(ElIcon), {
            size: "14"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          }), _cache[2] || (_cache[2] = _createElementVNode("text", null, "创建新技能", -1))])) : _createCommentVNode("", true)]),
          _: 1
        })]), _createElementVNode("div", _hoisted_3, [_createVNode(RoleFinder, {
          "close-on-click": true,
          onSelectedRole: updateSelectedRole
        })])]),
        _: 1
      }), _createElementVNode("div", _hoisted_4, [_withDirectives(_createVNode(SkillsTree, {
        ref_key: "treeRef",
        ref: treeRef,
        data: treeData.value,
        "apostle-mode": true,
        "role-id": selectedRole.value ? selectedRole.value.id : null
      }, null, 8, ["data", "role-id"]), [[_vShow, treeData.value]])])]), skill.value ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "#mask-container"
      }, [_createVNode(MaskerLayer, {
        onClose: closeSkill
      }, {
        default: _withCtx(() => [_createVNode(SectsSkillEditCard, {
          "skill-id": skill.value.id,
          onClose: closeSkill,
          onComplete: getData
        }, null, 8, ["skill-id"])]),
        _: 1
      })])) : _createCommentVNode("", true)], 64);
    };
  }

};